import Hero from "../components/Hero";
import HoursLocation from "../components/HoursLocation";
import UpcommingEvents from "../components/events/UpcomingEvents";
import Reviews from "../components/reviews/Reviews";
import Welcome from "../components/Welcome";
import { Link } from "react-router-dom";
import SectionTitle from "../components/SectionTitle";
import AnimatedRentalSection from "../components/AnimatedRentalSection";
import WeeklySaturdayMarket from "../components/WeeklySaturdayMarket";

export default function Home() {
  return (
    <div>
      <Hero />
      <HoursLocation />
      <WeeklySaturdayMarket />
      <AnimatedRentalSection />
      <UpcommingEvents />
      <Reviews />
      <Welcome />
    </div>
  );
}
